import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[imgFallback]',
})

export class ImageFallbackDirective{
    public defaultImg = `./assets/images/accountIcons/381610.png`;@Input() src!: string;

    @HostBinding('src')
    get originalSrc() {
        return this.src;
    }

    @HostListener('error') onError() {
        this.src = this.defaultImg;
    }
}
